module.exports = __webpack_public_path__ + "img/01评价报告.c50ea908.png";